/**
 * @generated SignedSource<<534b8c051a04bd974bbdfa1b5351030b>>
 * @relayHash 99b2ca8b4de1d9f51fb7e8b60fedfaec
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 99b2ca8b4de1d9f51fb7e8b60fedfaec

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "propositionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      }
    ],
    "concreteType": "TokenResponse",
    "kind": "LinkedField",
    "name": "convertPropositionsCommerciales",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConvertPropositionsCommercialesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConvertPropositionsCommercialesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "99b2ca8b4de1d9f51fb7e8b60fedfaec",
    "metadata": {},
    "name": "ConvertPropositionsCommercialesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "1c638f5adcf06f71190938d051b683bd";

export default node;
